import * as React from "react";
import styled, { css } from "../../../styled/index";

export const LinkTag = styled("a")`
  color: ${({theme}) => theme.colors.primary};
  text-decoration: underline;
`;
